import styled from "styled-components";

export const DashboardContainer = styled.div`
  background: #f3f7ff;
  margin-left: 255px;
  overflow: scroll;
  overflow-x: hidden;
  overflow-y: hidden;

   @media (max-width: 768px) {
    margin-left: 0px;
  }

  @media screen and (max-width: 768px) {
    margin-left: 0px;
  }
`;


export const DashboardContainerData = styled.div`
  background: #f3f7ff;
  height: 100vh;
  overflow: scroll;
  overflow-x: hidden;
  overflow-y: hidden;
`;

export const DashboardWrapper = styled.div`
  display: flex;
  z-index: 1;
  height: calc(100vh - 80px);
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  overflow: overlay;
`;

export const DeleteButton = styled.button`
  height: 45px;
  width: 45px;
  border-radius: 50%;
  background: #F03434;
  color: #ffffff;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DashboardHeading = styled.div`
  padding: 1rem 0;
  width: 100%;

  @media screen and (max-width: 768px) {
    padding: 0.8rem;
  }

  @media screen and (max-width: 480px) {
    padding: 0.5rem;
  }
`;

export const DashHeading = styled.div`
  font-family: "Roboto";
  font-size: 22px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
  color: #264503;

  @media screen and (max-width: 880px) {
    font-size: 18px;
  }

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;
  }
`;

export const DashCard = styled.div`
  height: auto;
  // width: auto;
  display: flex;
  font-size: 17px;
  padding: 10px 15px;
  background-color: white;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  margin-bottom: 15px;
  box-shadow: 0px 2px 2px #00000012;
  color: #1a1a1a;
`;

export const SubAdminAddUpatecant = styled.div`
  width: 100%;
  border-radius: 6px;
  border: 1px solid rgba(12, 45, 6, 0.10);
  background: rgba(82, 180, 74, 0.08);
  display: flex;
  flex-direction: column;
  padding: 1rem;
  grid-gap: 1rem;
  gap: 1rem;
`;

// Styled components
export const FilterOptions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 40%;
  border-radius: var(--Space-Extra-Small, 8px) var(--Space-Extra-Small, 8px) 0px 0px;
  border: 1px solid rgba(12, 45, 6, 0.15);
`;

export const FilterCheckboxRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-start;
  padding: 0.4rem;
  background: ${({ isOdd }) => (isOdd ? '#ffffff' : 'rgba(82, 180, 74, 0.08)')};
  border: 1px solid rgba(12, 45, 6, 0.15);
`;

export const DashContainerCard = styled.div`
  // background-color: pink;
  height: auto;
  width: 80%;
  padding: 20px 20px;
  display: grid;
  margin-left: 1.5rem;
  grid-template-columns: auto auto auto auto;
  grid-gap: 14px 25px;

  @media screen and (max-width: 1290px) {
    display: flex;
    flex-direction: column;
  }
`;

export const ProfileDetailForm = styled.div`
  width: 100%;
  padding: 1rem;

  @media screen and (max-width: 1000px) {
    padding: 1rem;
  }
`;

export const DashContent = styled.p`
  height: auto;
  width: 97%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  color: #1a1a1a;
  padding: 0 10px;
  font-size: 1.3rem;
  // margin-left: 2rem;
`;

export const Fields = styled.div`
  border-top:2px solid #D9E3D9;
  border-bottom:2px solid #D9E3D9;
`;

export const Button = styled.button`
  width: fit-content;
  padding: 0.5rem 1.5rem;
  border-radius: 4px;
  background: #26344E;
  color: #ffffff;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CommonButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding:6px;
  cursor:pointer;
  outline: none;
  border: none;
`;


export const CancelButton =styled.button`
width:fit-content;
  height: 39px;
  padding:0.5rem 2rem;
  border-radius: 4px;
  background: #FFFFFF;
  color: #26344E;
  border: 1px solid #26344E38
`